// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KN-z","twoColumnImage":"LN-z"};